module.exports = __webpack_public_path__ + "assets/img/apk.0365cb07.svg";